import { useEffect, useState } from "react";

const useDebounce = (value: string, delay: number): string => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    // eslint-disable-next-line no-undef
    return () => clearTimeout(timeoutId);
  }, [value]);

  return debouncedValue;
};

export default useDebounce;
